import { render, staticRenderFns } from "./inHospital.vue?vue&type=template&id=6d69daea&scoped=true"
import script from "./inHospital.vue?vue&type=script&lang=js"
export * from "./inHospital.vue?vue&type=script&lang=js"
import style0 from "./inHospital.vue?vue&type=style&index=0&id=6d69daea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d69daea",
  null
  
)

export default component.exports